import React from 'react';
import MainLayout from '../../../app/layouts/MainLayout';
import { Card } from '../../../components/ui/Card';
import { Settings, LogOut, Shield, HelpCircle, ChevronRight } from 'lucide-react';

const ProfilePage = () => {
  const menuItems = [
    { label: 'Configurações', icon: Settings, color: 'text-gray-600' },
    { label: 'Segurança e Senha', icon: Shield, color: 'text-gray-600' },
    { label: 'Ajuda e Suporte', icon: HelpCircle, color: 'text-gray-600' },
    { label: 'Sair do Sistema', icon: LogOut, color: 'text-red-500' },
  ];

  return (
    <MainLayout>
      <div className="space-y-8">
        <header className="flex flex-col items-center text-center space-y-4">
          <div className="relative">
            <div className="w-24 h-24 rounded-3xl bg-primary-light overflow-hidden border-4 border-white shadow-premium">
              <img 
                src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix" 
                alt="Profile" 
                className="w-full h-full object-cover"
              />
            </div>
            <button className="absolute -bottom-2 -right-2 bg-primary text-white p-1.5 rounded-xl border-4 border-white shadow-sm">
              <Settings size={16} />
            </button>
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-900">Diácono Samuel Oliveira</h2>
            <p className="text-sm text-gray-500">Secretário Geral • Central</p>
          </div>
        </header>

        <div className="grid grid-cols-2 gap-4">
          <Card className="p-4 text-center space-y-1 bg-green-50/50 border-green-100">
            <p className="text-2xl font-bold text-primary">12</p>
            <p className="text-[10px] font-bold text-gray-400 uppercase">Trimestres</p>
          </Card>
          <Card className="p-4 text-center space-y-1 bg-blue-50/50 border-blue-100">
            <p className="text-2xl font-bold text-blue-600">8</p>
            <p className="text-[10px] font-bold text-gray-400 uppercase">Classes</p>
          </Card>
        </div>

        <div className="space-y-3">
          {menuItems.map((item, i) => (
            <button
              key={i}
              className="w-full flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100 shadow-sm active:scale-[0.98] transition-all"
            >
              <div className="flex items-center gap-4">
                <div className={`p-2 rounded-xl bg-gray-50 ${item.color}`}>
                  <item.icon size={20} />
                </div>
                <span className={`font-semibold ${item.color.includes('red') ? 'text-red-500' : 'text-slate-700'}`}>
                  {item.label}
                </span>
              </div>
              <ChevronRight size={18} className="text-gray-300" />
            </button>
          ))}
        </div>

        <footer className="text-center pt-4">
          <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Versão 1.0.0</p>
          <p className="text-[10px] text-gray-300">© 2024 IEADJO EBD • Made with ♥</p>
        </footer>
      </div>
    </MainLayout>
  );
};

export default ProfilePage;
